import {NAVIGATION_PATHS, PATHS} from './navigation.interface';

export const PATHS_STUB = {
  provide: PATHS,
  useValue: NAVIGATION_PATHS,
};
